(ns common.schema.entities.workspace.kyc.templates.capman.contract-config)

(def form-preface-text
  {:fi
   (str
    "<p>Olemme sitoutuneita noudattamaan rahanpesun estämistä ja pakotteita koskevia säännöksiä ja "
    "siksi meidän on tunnistettava kaikki yritykset joiden kanssa teemme yhteistyötä ja/tai heidän tosiasialliset edunsaajansa.</p>"

    "<p>Pyydämme ystävällisesti teitä täyttämään Yrityksen tuntemisprosessin (KYC), "
    "joka on pakollinen kaikille yhteistyökumppaneillemme. Tämä prosessi auttaa meitä varmistamaan, että "
    "liiketoimintamme noudattaa kaikkia sääntelyvaatimuksia ja eettisiä standardeja.</p>")
   :en
   (str
    "<p>As part of our ongoing commitment to comply with anti-money laundering and sanctions regulations, "
    "we are required to identify all our company counterparties and their beneficial owners.</p>"

    "<p>We kindly request you to complete the Company Counterparty KYC process, which is a mandatory requirement for all counterparties. "
    "This process helps us ensure that our business dealings adhere to the highest standards of "
    "regulatory compliance and integrity.</p>")})

